import { Link } from "@tanstack/react-router";

type Item = { to: string; label: string; hint: string };

/**
 * Enlazado interno contextual con anclas descriptivas (no "clic aquí"):
 * reparte autoridad entre las páginas de servicio, precios y prueba social.
 * Usa el mismo panel que las secciones del home para no romper el ritmo.
 */
export function PaginasRelacionadas({
  titulo = "Siga con esto",
  items,
}: {
  titulo?: string;
  items: Item[];
}) {
  return (
    <nav aria-label={titulo} className="section-air">
      <div className="container-site">
        <div className="panel-soft">
          <span className="panel-eyebrow">Seguir leyendo</span>
          <h2 className="h-panel">{titulo}</h2>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2">
            {items.map((i) => (
              <li key={i.to} className="rounded-xl border border-border bg-surface-raised p-4">
                <Link to={i.to} className="link-arrow font-semibold">
                  {i.label}
                </Link>
                <p className="mt-1 text-[0.95rem] text-muted-foreground">{i.hint}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}
